
import {
  ref,
  defineComponent,
  computed,
  useContext,
  provide,
} from '@nuxtjs/composition-api';
import useForm from '~/composables/useForm';

const FORM_FIELDS_PROTOTYPE = {
  name: '',
  country: '',
  email: '',
  description: '',
  subject: '',
  agreement: false,
  token: '',
};

const FORM_TYPE = {
  type: 'lorgar_market',
};

export default defineComponent({
  name: 'ContactUsForm',
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { i18n } = useContext();
    const modal = ref(null);
    const isLoading = ref(false);
    const isFormSuccess = ref(false);
    const recaptchaError = ref(false);
    const { formFields, submit, resetForm } = useForm({
      ...FORM_FIELDS_PROTOTYPE,
      ...FORM_TYPE,
    });

    const modalTitle = computed(() =>
      isFormSuccess.value
        ? i18n.t('successfully_sent')
        : i18n.t('something_went_wrong')
    );
    const modalDescription = computed(() =>
      isFormSuccess.value
        ? i18n.t('successfully_sent_description')
        : i18n.t('please_try_again_later')
    );

    const subjects = [
      i18n.t('lorgar_pricelist'),
      i18n.t('sales_request'),
      i18n.t('pr_inquiry'),
      i18n.t('gaming_partnership'),
      i18n.t('other'),
    ];

    const isButtonDisabled = (validatorInvalid) =>
      validatorInvalid ||
      isLoading.value ||
      !formFields.value.agreement ||
      !formFields.value.token;

    const handleForm = async (resetValidation) => {
      isLoading.value = true;
      if (!formFields.value.token) {
        recaptchaError.value = true;
        isLoading.value = false;
        return;
      }
      try {
        await submit(formFields.value);
        isFormSuccess.value = true;
      } catch (error) {
        isFormSuccess.value = false;
      } finally {
        isLoading.value = false;
        modal.value.$children[0].open();
        resetForm(resetValidation);
        resetValidation();
      }
    };

    provide('recaptchaError', recaptchaError);

    return {
      formFields,
      isLoading,
      isFormSuccess,
      modal,
      modalTitle,
      modalDescription,
      subjects,
      handleForm,
      isButtonDisabled,
    };
  },
});
